import { createSlice } from '@reduxjs/toolkit'

export const NAME = 'api-caller'

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: undefined,
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    loadPending: state => {
      state.error = undefined
      state.isLoading = true
    },
    loadSuccess: state => {
      state.isLoading = false
      state.isLoaded = true
    },
    loadFailure: (state, { payload: error }) => {
      state.isLoading = false
      state.isLoaded = true
      state.error = error
    },
    reset: () => ({
      ...initialState,
    }),
  },
})

export const { loadPending, loadSuccess, loadFailure, reset } = actions

export default reducer

const getState = (state: any) => state[NAME]

export const getIsLoading = (state: any) => getState(state).isLoading
export const getIsLoaded = (state: any) => getState(state).isLoaded
export const getError = (state: any) => getState(state).error
